import React, { useState } from 'react';
import { SelectableGoalCard } from 'components/atoms/selectable_goal_card';
import { STEP3_GOALS } from '../onboarding';

interface Step3Props {
  onBack: () => void;
  onFinish: () => void;
  loadingFinish: boolean;

  values: {
    goals: string[];
  };

  onChange: (data: Step3Props['values']) => void;
}

const Step3: React.FC<Step3Props> = ({ onBack, onFinish, values, onChange, loadingFinish }) => {
  const selected = values.goals;

  const [submitted, setSubmitted] = useState(false);

  const goalsValid = selected.length > 0;
  const canFinish = goalsValid && !loadingFinish;

  const toggle = (id: string) => {
    const nextSelected = selected.includes(id)
      ? selected.filter((x) => x !== id)
      : [...selected, id];

    onChange({ goals: nextSelected });
  };

  const handleFinish = () => {
    setSubmitted(true);
    if (!goalsValid) return;
    onFinish();
  };

  return (
    <div className="step-content">
      <h2 className="step-title">E, por último, vamos entender mais sobre sua necessidade.</h2>

      <p className="step-label mt-2 mb-2 font-weight-light">
        Aqui, você irá nos contar o que busca encontrar em nossas ferramentas, fique a vontade para
        selecionar uma ou mais.
      </p>

      <div className="green-line step-line mt-3" />

      <div className="step-form mt-5">
        {submitted && !goalsValid && (
          <small className="text-danger d-block mb-2">
            Selecione pelo menos 1 opção para finalizar.
          </small>
        )}

        <div className="goals-grid">
          {STEP3_GOALS.map((g) => (
            <SelectableGoalCard
              key={g.id}
              label={g.label}
              Icon={g.icon}
              checked={selected.includes(g.id)}
              onToggle={() => toggle(g.id)}
            />
          ))}
        </div>
      </div>

      <div className="step-actions between">
        <button
          type="button"
          className="btn btn-outline-secondary px-4 mr-2"
          onClick={onBack}
          disabled={loadingFinish}
        >
          voltar
        </button>

        <button
          type="button"
          className="btn btn-success px-4 d-flex align-items-center justify-content-center"
          onClick={handleFinish}
          disabled={!canFinish}
          title={!goalsValid ? 'Selecione pelo menos 1 opção.' : ''}
        >
          {loadingFinish && (
            <span
              className="spinner-border spinner-border-sm mr-2"
              role="status"
              aria-hidden="true"
            />
          )}
          finalizar
        </button>
      </div>
    </div>
  );
};

export default Step3;
